<template>
	<div id="footer" ref="footers">
		<div class="foot-part-one">
			<div class="china-box">
				<p class="big-name">上海尚矽电子科技有限公司</p>
				<p class="small-text">地址：上海市自由贸易试验区日京路35号1125室</p>
				<p class="small-text">邮编：200137    电话：13817264865</p>
			</div>
			<div class="english-box">
				<p class="big-name">Sunsil Electronics Science & Technology (Shanghai) Co., LTD.</p>
				<p class="small-text">Postcode: 200137    TelePhone: 13817264865    </p>
				<p class="small-text">Address: Unit 1125, No. 35 Rijing Road Shanghai Pilot Free Trade Zone</p>
			</div>
				
			<div class="logo">
				<img src="../../assets/image/logo.png"/>
			</div>
		</div>
		<!--<div class="foot-part-two">
			<p class="small-text">沪ICP备14051669号   公安备案号：3101150200XXXX  © 20XXXXXXXXXx版权所有</p>
		</div>-->
	</div>
</template>
<script>
	export default {
		name: 'Footer',
		data() {
			return {
			}
		},
		mounted() {
		}, 
		created() {
			this.init();
		},
		methods: {
			init:function(){
				var that=this;
				that.$nextTick(function(){
					that.$emit('backFootHeight',this.$refs.footers.offsetHeight);
				});
			}
		},
		components: {
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/PublicMould/Footer.vue